import React from 'react';
import {useChart} from '../hooks';
import styled from 'styled-components';
import * as am4charts from "@amcharts/amcharts4/charts";



const StyledChartWrapper = styled.div`
    height: 480px;
    width: 100%;
`;


export default function ({data}) {
    const [ref, chart] = useChart({
        data,
        "series": [{
          "type": "PieSeries",
          "dataFields": {
            "value": "size",
            "category": "title"
          }
        }]
    }, am4charts.PieChart);

    React.useEffect(
      () => {
        if (!chart) {
          return
        }
        chart.data = data
        chart.invalidateData()
      }, [data]
    )


    return (
      <StyledChartWrapper ref={ref}/>
    )
}
